<template>
  <div v-if="variant !== 'icon'"
       :class="{ '!border-b-0' : window.size.mobile && isReferee && refereeStats && refereeStats.hasOwnProperty('name'), 'max-h-[53px]' : !isReferee && (variant !== 'live' && !detailsEnabled) }"
       class="transition-colors cursor-default w-full border-b border-x border-zt-light bg-[#3A4B6459]">
    <div class="w-full flex items-center relative h-[51px] max-w-full"
         :class="{'gap-x-0 !pl-1' : variant === 'compact', 'hover:bg-zt-light/50 cursor-pointer' : redirectToH2h && leagueName.length > 0 && variant !== 'live',
             '!bg-zt-light-opacity' : variant === 'main-page','hover:!bg-zt-light-hover' : variant === 'main-page' && redirectToH2h,
              'bg-zt-red/30 hover:!bg-zt-red/20' : (showVisitorGoalString  || showLocalGoalString)
             && displayingStat === 'goals' && isLive && !showOnlyInProgress}">
      <a v-if="variant !== 'live' && !detailsEnabled"
         class="no-default-style absolute top-0 bottom-0 left-0 right-0 opacity-0 z-10"
         :data-count-click="analyticText"
         :class="{ 'cursor-default': !redirectToH2h || leagueName.length <= 0 }"
         :href="redirectToH2h && leagueName.length > 0 ? `/wyniki-pilka-nozna/porownanie-druzyn/${match.localteam_team_query_name}/${match.visitorteam_team_query_name}/` : null">
        {{ localTeam.shortname?.length > 0 ? localTeam.shortname : localTeam.name }} - {{ visitorTeam.shortname?.length > 0 ? visitorTeam.shortname : visitorTeam.name }}
      </a>
      <div v-if="isLive" class="absolute left-0 top-0 bottom-0 bg-zt-red w-0.5"></div>
      <div :class="{ '!w-fit !pointer-events-none !px-0 !max-w-[31px]' : variant === 'compact',
           'group cursor-pointer' : (match.events && ((eventsToShow.length > 0 || extraTimeEventsToShow.length > 0 || penaltyShootoutEventsToShow.length > 0)
         && (variant === 'live' || detailsEnabled)) || (isLive || isFinished)) && showEventArrow }"
           class="text-zt-more leading-[14px] text-xs w-[54px] max-w-[54px] shrink-0 h-full relative flex flex-col justify-center items-center
            font-['Lato'] px-2"
           data-count-click="WNŻ - Ptaszek rozwijający STRZELCY/KARTKI" data-count-click-category="football"
           @click.prevent="showDetailsHandler">
        <div v-if="variant === 'live' || variant === 'main-page' || variant === 'line'" class="absolute w-[1px] h-[70%] bg-zt-light right-0 top-[15%] rounded-full"></div>
        <div v-if="isLive" :class="{'group-hover:opacity-50 transition-opacity' : variant === 'live' || detailsEnabled}">
          <span v-if="match.status === 'PST'">Przeł.</span>
          <span v-if="['SUSP', 'INT'].includes(match.status)">Wstrz.</span>
          <span v-if="match.status === 'P'" class="text-[10px] text-zt-red">Karne</span>
          <span v-else-if="['BT', 'HT'].includes(match.status)" class="text-zt-red">HT</span>
          <span v-else-if="showOnlyInProgress" class="text-zt-red">Trwa</span>
          <span v-else class="text-zt-red whitespace-nowrap">{{ match.elapsed + (match.extra ? `+${match.extra}` : '') }}
        <span class="match-minutes-tick">'</span>
        </span>
        </div>
        <div v-else class="flex flex-col text-center items-center justify-center"
             :class="{'group-hover:opacity-50 transition-opacity' : variant === 'live' || detailsEnabled}">
            <span v-if="match.status === 'CANC'" class="text-[10px]">Anul.</span>
            <span v-else-if="['SUSP', 'INT'].includes(match.status)">Wstrz.</span>
            <span v-else-if="showFinished && isFinished && match.status !== 'WO'" class="transition-colors" :class="{ 'text-zt-red' : justFinished }">
          FT
          </span>
            <span v-else-if="match.status === 'PST'" class="text-[10px]">{{variant === 'compact' ? 'Przeł.' : 'Przełożony'}}</span>
            <span v-else-if="match.status === 'WO'" class="text-[10px]">{{variant === 'compact' ? 'WO' : 'Walkover'}}</span>
            <template v-else>
            <span class="text-center" v-if="showDate && !(hourOnlyInTodaysMatches && isToday)">
              {{ getMatchDateToDisplay }}
            </span>
              <span v-if="showHour && !(showDate && (isToday || isTomorrow || isYesterday)) && (leagueName === 'euro' || !isOver30Days) && isValidHour">
              {{ matchDate.toFormat('H:mm') }}
            </span>
              <span v-if="variant === 'compact' && new Date().getFullYear() !== matchDate.get('year')">
              {{ matchDate.toFormat('yyyy')}}
            </span>
              <span class="text-center text-[9px]" v-if="showLeagueName">
              {{ match.league ?? match.league_query_name.capitalize() }}
            </span>
              <span class="text-center text-[9px]" v-if="shortLeagueName !== '' && match.league_short_name !== ''">{{ shortLeagueName }}</span>
            </template>
        </div>
        <div v-if="(match.events && ((eventsToShow.length > 0 || extraTimeEventsToShow.length > 0 || penaltyShootoutEventsToShow.length > 0)
         && (variant === 'live' || detailsEnabled)) || (isLive || isFinished)) && showEventArrow"
             class="mt-0.5"
             :class="{'group-hover:opacity-50 transition-opacity' : variant === 'live' || detailsEnabled}">
          <svg width="16" height="16"  :class="{'rotate-180' : showDetails}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="15" height="15" rx="4.5" :stroke="isLive || justFinished ? '#FF4A5D' : '#93A3BA'"/>
            <path :class="{'fill-zt-red' : isLive || justFinished}" d="M4.5575 6L8 9.09042L11.4425 6L12.5 6.95142L8 11L3.5 6.95142L4.5575 6Z" fill="#93A3BA"/>
          </svg>
        </div>
      </div>
      <div class="w-full flex items-center relative h-full pl-2 min-w-0 xl:pr-1"
           :title="redirectToH2h && leagueName.length > 0 && match.country_query_name !== 'swiat' ? 'Porównaj drużyny' : ''"
           data-delay="1500"
           :class="{ 'hover:!bg-zt-light/50 cursor-pointer': redirectToH2h && leagueName.length > 0 && (variant === 'live' || detailsEnabled),
           '!pl-0' : !['live', 'main-page', 'line'].includes(variant)}">
        <a v-if="variant === 'live'"
           class="no-default-style absolute top-0 bottom-0 left-[0px] right-0 opacity-0"
           :data-count-click="analyticText"
           :class="{ 'cursor-default': !redirectToH2h || leagueName.length <= 0 }"
           :href="redirectToH2h && leagueName.length > 0 ? `/wyniki-pilka-nozna/porownanie-druzyn/${match.localteam_team_query_name}/${match.visitorteam_team_query_name}/` : null">
          {{ localTeam.shortname?.length > 0 ? localTeam.shortname : localTeam.name }} - {{ visitorTeam.shortname?.length > 0 ? visitorTeam.shortname : visitorTeam.name }}
        </a>
        <div class="flex flex-col w-full gap-y-[2px] min-w-0">
          <div class="text-xs text-dark flex items-center">
            <span class="inline-block aspect-square h-3.5 overflow-hidden"
                  :class="{ 'h-5' : biggerCrest, 'hidden' : variant === 'compact' }">
              <img ref="localTeamImg" class="w-[14px] h-[14px] object-contain mx-auto"
                   :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                   :data-src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${localTeam.query_name}.png`"
                   @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                   :alt="localTeam.name" width="14" height="14"/>
            </span>
            <div class="ml-2 font-normal flex items-center min-w-0"
                 :class="{ '!font-bold': markWinner && isFinished && ((statuses.extra.includes(match.status) &&
                   (+match.localteam_goals - +match.localteam_et_goals > +match.visitorteam_goals - +match.visitorteam_et_goals)) ||
                   (getResult > 0 && !statuses.extra.includes(match.status)) || (match.status === 'WO'))}">
              <div class="truncate max-w-[85px] sm:!max-w-[140px] mr-1"
                   :class="[{'bg-zt-light pt-[1.5px] pl-[3px] pb-[0.5px] rounded-[2px] -translate-x-[3px]' : showTeamsBg.includes(+match.localteam_id)},
                    {'!max-w-[77px]': match.localteam_red_cards && +match.localteam_red_cards > 0},
                    {'!max-w-[77px]': displayingStat === 'firsthalf' || displayingStat === 'secondhalf'}]">
                <span>
                  {{ localTeam.shortname?.length > 0 ? localTeam.shortname : localTeam.name }}
                </span>
              </div>
              <img v-if="match.localteam_red_cards && +match.localteam_red_cards > 0"
                   :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/red_cards/${match.localteam_red_cards}.svg`"
                   alt="Czerwone kartki" width="8" height="12"/>
              <div v-if="(showPromotionIcon) && getDoubleMatchResult > 0 && markWinner && isFinished"
                   class="pl-1 -translate-y-[1px] w-[14px] h-[10px]">
                <img data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="1000" title="Awans"
                     class="transform-gpu"
                     :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/promotion.svg`"
                     width="10" height="10" alt="Awans" />
              </div>
            </div>
            <span class="text-zt-more font-normal ml-1 text-[10px]"
                  v-if="statuses.extra.includes(match.status) && getResult > 0
                    && displayingStat === 'goals' && (!ish2h || window.size.desktop)">
              ({{match.status === 'AET' ? 'Dogr.' : 'Karne'}})
            </span>
            <span class="text-zt-more font-normal ml-1 text-[9px]"
                  v-if="statuses.extra.includes(match.status) && getResult > 0
                    && displayingStat === 'goals' && (ish2h && window.size.mobile)">
              {{match.status === 'AET' ? 'Dogr.' : 'Karne'}}
            </span>
          </div>
          <div class="text-xs text-dark flex items-center">
            <span class="inline-block aspect-square h-3.5 overflow-hidden"
                  :class="{ 'h-5' : biggerCrest, 'hidden' : variant === 'compact' }">
              <img ref="visitorTeamImg" class="w-[14px] h-[14px] object-contain mx-auto"
                   :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                   @error="$event.target.src='/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
                   :data-src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${visitorTeam.query_name}.png`"
                   :alt="visitorTeam.name" width="14" height="14"/>
            </span>
            <div class="ml-2 font-normal flex items-center min-w-0"
                  :class="{ '!font-bold': markWinner && isFinished && ((statuses.extra.includes(match.status) &&
                   +match.localteam_goals - +match.localteam_et_goals < +match.visitorteam_goals - +match.visitorteam_et_goals) || (getResult < 0 && !statuses.extra.includes(match.status)))}">
              <div class="truncate max-w-[85px] sm:!max-w-[140px] mr-1"
                   :class="[{'bg-zt-light pt-[1.5px] pl-[3px] pb-[0.5px] rounded-[2px] -translate-x-[3px]' : showTeamsBg.includes(+match.visitorteam_id)},
                    {'!max-w-[77px]': match.visitorteam_red_cards && +match.visitorteam_red_cards > 0},
                    {'!max-w-[77px]': displayingStat === 'firsthalf' || displayingStat === 'secondhalf'}]">
                <span>
                  {{ visitorTeam.shortname?.length > 0 ? visitorTeam.shortname : visitorTeam.name }}
                </span>
              </div>
              <img v-if="match.visitorteam_red_cards && +match.visitorteam_red_cards > 0"
                   :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/red_cards/${match.visitorteam_red_cards}.svg`"
                   alt="Czerwone kartki" width="8" height="12"/>
              <div v-if="(showPromotionIcon || statuses.extra.includes(match.status))
                      && getDoubleMatchResult < 0 && markWinner && isFinished"
                   class="pl-1 -translate-y-[1px] w-[14px] h-[10px]">
                <img data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="1000" title="Awans"
                     class="transform-gpu"
                     :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/promotion.svg`"
                     width="10" height="10" alt="Awans" />
              </div>
            </div>
            <span class="text-zt-more font-normal ml-1 text-[10px]"
                  v-if="statuses.extra.includes(match.status) && getResult < 0
                    && displayingStat === 'goals' && (!ish2h || window.size.desktop)">
              ({{match.status === 'AET' ? 'Dogr.' : 'Karne'}})
            </span>
            <span class="text-zt-more font-normal ml-1 text-[9px]"
                  v-if="statuses.extra.includes(match.status) && getResult < 0
                    && displayingStat === 'goals' && (ish2h && window.size.mobile)">
              {{match.status === 'AET' ? 'Dogr.' : 'Karne'}}
            </span>
          </div>
        </div>
        <template v-if="!isReferee">
          <Transition appear :name="transitionName" mode="out-in">
            <div v-if="showOdds && window.size.desktop && checkIfMatchHasOdds() && displayingStat === 'goals' && variant !== 'compact'"
                 class="text-[10px] ml-auto gap-x-[6px] text-center pr-2.5 flex font-['Lato'] transition-opacity"
                 :class="{ 'opacity-50' : isLive, '!pr-1.5' : showH2hButton }">
              <div class="w-[37px] py-[1px] box-border border rounded-zt border-zt-light transition-colors font-normal
                   -leading-[0.15px] flex items-center justify-center"
                   :class="{ 'border-zt-more !border-[2px]' : (match.localteam_goals - match.localteam_et_goals > match.visitorteam_goals - match.visitorteam_et_goals && isFinished),
                       'border-zt-more' : (showVisitorGoalString  || showLocalGoalString) && displayingStat === 'goals' && isLive }">
                {{ match.odds?.odd1 ? formatOddsValue(match.odds.odd1) : '-' }}
              </div>
              <div class="w-[37px] py-[1px] box-border border rounded-zt border-zt-light transition-colors font-normal
                   -leading-[0.15px] flex items-center justify-center"
                   :class="{ 'border-zt-more !border-[2px]' : (match.localteam_goals - match.localteam_et_goals === match.visitorteam_goals - match.visitorteam_et_goals && isFinished),
                       'border-zt-more' : (showVisitorGoalString  || showLocalGoalString) && displayingStat === 'goals' && isLive }">
                {{ match.odds?.odd0 ? formatOddsValue(match.odds.odd0) : '-' }}
              </div>
              <div class="w-[37px] py-[1px] box-border border rounded-zt border-zt-light transition-colors font-normal
                   -leading-[0.15px] flex items-center justify-center"
                   :class="{ 'border-zt-more !border-[2px]' : (match.localteam_goals - match.localteam_et_goals < match.visitorteam_goals - match.visitorteam_et_goals && isFinished),
                       'border-zt-more' : (showVisitorGoalString  || showLocalGoalString) && displayingStat === 'goals' && isLive }">
              {{ match.odds?.odd1 ? formatOddsValue(match.odds.odd2) : '-' }}
            </div>
          </div>
        </Transition>
        <div v-if="showLiveMatchesH2hButton && window.size.mobile && redirectToH2h" class="px-2"
             :class="{ 'opacity-40' : !redirectToH2h || !(leagueName.length > 0), 'hidden' : isLive || justFinished}">
          <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="25" height="19" rx="3" fill="#B3B3B3" fill-opacity="0.75"/>
            <path d="M7.58527 7.36C8.13194 7.36 8.56194 7.51667 8.87527 7.83C9.19527 8.14333 9.35527 8.58 9.35527 9.14C9.35527 9.32667 9.33527 9.52667 9.29527 9.74L8.71527 13H7.01527L7.55527 9.97C7.57527 9.85667 7.58527 9.75667 7.58527 9.67C7.58527 9.39 7.50527 9.17333 7.34527 9.02C7.19194 8.86667 6.97527 8.79 6.69527 8.79C6.36194 8.79 6.08194 8.89333 5.85527 9.1C5.62861 9.30667 5.48194 9.59667 5.41527 9.97V9.95L4.87527 13H3.16527L4.47527 5.6H6.18527L5.73527 8.16C5.95527 7.91333 6.22527 7.72 6.54527 7.58C6.86527 7.43333 7.21194 7.36 7.58527 7.36ZM10.1536 11.35C10.8802 10.83 11.4602 10.4 11.8936 10.06C12.3269 9.72 12.7002 9.37333 13.0136 9.02C13.3336 8.66 13.5202 8.31667 13.5736 7.99C13.5936 7.89667 13.6036 7.81 13.6036 7.73C13.6036 7.53667 13.5502 7.39 13.4436 7.29C13.3436 7.19 13.1902 7.14 12.9836 7.14C12.4702 7.14 12.1436 7.50333 12.0036 8.23H10.3436C10.5169 7.39 10.8769 6.76 11.4236 6.34C11.9769 5.91333 12.6102 5.7 13.3236 5.7C14.0169 5.7 14.5302 5.85667 14.8636 6.17C15.2036 6.48333 15.3736 6.89667 15.3736 7.41C15.3736 7.57 15.3602 7.71667 15.3336 7.85C15.2136 8.53 14.8602 9.16333 14.2736 9.75C13.6936 10.3367 12.9736 10.9233 12.1136 11.51H14.8136L14.5636 12.9H9.54355L9.76355 11.63L10.1536 11.35ZM19.7364 7.36C20.2831 7.36 20.7131 7.51667 21.0264 7.83C21.3464 8.14333 21.5064 8.58 21.5064 9.14C21.5064 9.32667 21.4864 9.52667 21.4464 9.74L20.8664 13H19.1664L19.7064 9.97C19.7264 9.85667 19.7364 9.75667 19.7364 9.67C19.7364 9.39 19.6564 9.17333 19.4964 9.02C19.3431 8.86667 19.1264 8.79 18.8464 8.79C18.5131 8.79 18.2331 8.89333 18.0064 9.1C17.7798 9.30667 17.6331 9.59667 17.5664 9.97V9.95L17.0264 13H15.3164L16.6264 5.6H18.3364L17.8864 8.16C18.1064 7.91333 18.3764 7.72 18.6964 7.58C19.0164 7.43333 19.3631 7.36 19.7364 7.36Z" fill="#3A4B64"/>
          </svg>
        </div>
        <transition appear :name="transitionName" mode="out-in">
          <div v-if="showAllOverUnder" class="max-w-[270px] flex gap-x-2 translate-y-0.5">
            <div v-for="value in currentOverValues" class="flex flex-col gap-y-1 text-[10px] items-center justify-center">
              <div class="w-[13px] h-[6px] rounded-[3.25px]"
                   :class="currentStatsForOverUnderAll > value ? 'bg-[#45FF4D]' : 'bg-zt-light/35 border border-zt-light'">
              </div>
              <div
                  :class="{ 'text-[#45FF4D]' : currentStatsForOverUnderAll > value, 'opacity-40' : currentStatsForOverUnderAll < value }">
                {{value.toString().replace('.', ',')}}
              </div>
            </div>
          </div>
        </transition>
        <Transition appear :name="transitionName" mode="out-in">
          <div :key="keyFilter" class="text-xs text-right min-w-7 flex shrink-0 flex-col gap-y-[5px] ml-auto font-['Lato'] font-bold"
               :class="[isLive ? 'text-zt-red' : '', {'!gap-y-0' : displayingStat === 'penalty', '!min-w-5' : variant === 'compact'}]">
            <span v-if="match.status === 'NS' && isTWK > 60000*5" class="text-[10px] text-zt-more">TWK</span>
            <div v-else-if="showScores" :class="[{'after-line' : displayingStat === 'firsthalf' || displayingStat === 'secondhalf'}, {'after:!right-[12px]': ish2h}]">
              <div class="w-4 relative"
                   :class="[{'!opacity-90' : !(isLive || isFinished)},
                      {'!w-[50px]' : ((displayingStat === 'firsthalf' || displayingStat === 'secondhalf') && !ish2h) || showBreakers, 'text-center' : showH2hButton },
                      [ish2h && (displayingStat === 'firsthalf' || displayingStat === 'secondhalf') ? '!w-[32px]' : '!w-[16px]']]">
            <span v-if="shouldShowDoubleMatchResult(match)"
                  class="font-normal text-zt-more pr-2">
              {{ match.double_match.second_match.visitorteam_goals }}
            </span>
            <span v-if="showBreakers" class="font-normal text-zt-more text-xs pr-0.5">
              ({{ match.localteam_ht_goals }})
            </span>
            <span v-else-if="displayingStat === 'firsthalf' || displayingStat === 'secondhalf'"  :class="{'opacity-50' : displayingStat === 'secondhalf'}">
              {{ this.isLive ? '-' : match.localteam_ht_goals}}
            </span>
                  <span v-else>
              {{ (isLive || isFinished) && (!showOnlyInProgress || displayingStat === 'penalty') ? localTeamStat : '-' }}
            </span>
                  <Transition name="fade">
            <span v-if="showLocalGoalString && displayingStat === 'goals' && !showOnlyInProgress"
                  class="absolute right-6 top-0 font-bold drop-shadow-[0_0_4px_#FF4A5D] xl:left-8">
              GOL!
            </span>
                  </Transition>
                  <span v-if="penaltyShootoutOccurred && displayingStat === 'goals'"
                        :class="{'!left-[18px]': variant === 'compact'}"
                        class="absolute left-[24px] -top-[5px] text-[9px] font-normal">
              {{ match.localteam_penalty_shootout }}
            </span>
                  <span v-if="(displayingStat === 'firsthalf' || displayingStat === 'secondhalf') && !showOnlyInProgress"
                        class="ml-[17px]" :class="[{'opacity-50' : displayingStat === 'firsthalf'}, {'!ml-[12px]': ish2h}]">
              {{  this.isLive ? '-' : match.localteam_goals - match.localteam_ht_goals - match.localteam_et_goals }}
            </span>
                <span v-if="displayingStat === 'ft_goals' && !isLive">{{ match.localteam_goals - match.localteam_et_goals }}</span>
                <span v-if="showBreakers">{{ match.localteam_goals }}</span>
                </div>
              <div class="w-4 relative"
                     :class="[{'!opacity-90' : !(isLive || isFinished)},
                      {'!w-[50px]' : ((displayingStat === 'firsthalf' || displayingStat === 'secondhalf') && !ish2h) || showBreakers, 'text-center' : showH2hButton },
                      [ish2h && (displayingStat === 'firsthalf' || displayingStat === 'secondhalf') ? '!w-[32px]' : '!w-[16px]']]">
              <span v-if="shouldShowDoubleMatchResult(match)"
                    class="font-normal text-zt-more text-xs pr-2">
                {{ match.double_match.second_match.localteam_goals }}
              </span>
              <span v-if="showBreakers" class="font-normal text-zt-more pr-0.5">
                ({{ match.visitorteam_ht_goals }})
              </span>
                  <span v-else-if="displayingStat === 'firsthalf' || displayingStat === 'secondhalf'"  :class="{'opacity-50' : displayingStat === 'secondhalf'}">
                {{  this.isLive ? '-' : match.visitorteam_ht_goals}}
              </span>
                  <span v-else>
                {{ (isLive || isFinished) && !showOnlyInProgress ? visitorTeamStat : '-' }}
              </span>
                  <Transition name="fade">
              <span v-if="showVisitorGoalString && displayingStat === 'goals' && !showOnlyInProgress"
                    class="absolute right-6 top-0 font-bold drop-shadow-[0_0_4px_#FF4A5D] xl:left-8">
                GOL!
              </span>
                  </Transition>
                  <span v-if="penaltyShootoutOccurred && displayingStat === 'goals'"
                        class="absolute left-[24px] -top-[5px] text-[9px] font-normal" :class="{'!left-[18px]': variant === 'compact'}">
                {{ match.visitorteam_penalty_shootout }}
              </span>
                  <span v-if="(displayingStat === 'firsthalf' || displayingStat === 'secondhalf') && !showOnlyInProgress"
                        class="ml-[17px]" :class="[{'opacity-50' : displayingStat === 'firsthalf'}, {'!ml-[12px]': ish2h}]">
                {{ this.isLive ? '-' : match.visitorteam_goals - match.visitorteam_ht_goals - match.visitorteam_et_goals }}
              </span>
                <span v-if="displayingStat === 'ft_goals' && !isLive">{{ match.visitorteam_goals - match.visitorteam_et_goals }}</span>
                <span v-if="showBreakers">{{ match.visitorteam_goals }}</span>
              </div>
            </div>
          </div>
        </Transition>
        <Transition appear :name="transitionName" mode="out-in">
          <div :key="keyFilter" v-if="!showH2hButton && !showAllOverUnder"
               :class="{'!w-7' : variant === 'compact'}"
               class="w-10 shrink-0">
            <div class="w-[37px]" :class="{ 'w-fit ' : variant === 'compact' }">
              <slot name="result_slot">

              </slot>
              <div v-if="filteringResult && isFinished" class="text-xs text-center pl-1.5 pr-2">
                <div v-if="!showPlusMinus" class="h-[20px] relative w-[20px]">
                  <img :alt="filteringResult"
                       :src="'/wp-content/themes/zawodtyper/assets/images/ikony_football/'+filteringResult+'.svg'" />
                  <div v-if="statuses.extra.includes(match.status) && currentFilters[0] === '1x2'"
                       class="absolute top-0 h-full w-1 bg-[#F1C411] left-0 rounded-l-zt"></div>
                </div>
                <div v-else class="h-[20px] relative w-[20px] -ml-[1px] text-[11px] flex items-center justify-center
                               font-semibold rounded-zt xl:ml-0"
                       :class="{ 'bg-[#32AB29]': parsedFilteringResult === '+',
                          'bg-[#CE2121]' : parsedFilteringResult === '-'}">
                    {{ parsedFilteringResult }}
                  </div>
                </div>
              <div v-else-if="showOdds && checkIfMatchHasOdds() && (window.size.mobile || variant==='compact')"
                     class="text-[10px] text-left flex flex-col font-['Lato'] transition-opacity"
                     :class="{ 'opacity-50' : isLive }">
                  <div class="px-[3px] w-fit mx-auto"
                       :class="{ 'bg-zt-light rounded-[2px]' : (match.localteam_goals - match.localteam_et_goals > match.visitorteam_goals - match.visitorteam_et_goals && isFinished) }">
                    {{ match.odds?.odd1 ? formatOddsValue(match.odds.odd1) : '-' }}
                  </div>
                  <div class="px-[3px] w-fit mx-auto"
                       :class="{ 'bg-zt-light rounded-[2px]' : (match.localteam_goals - match.localteam_et_goals === match.visitorteam_goals - match.visitorteam_et_goals && isFinished) }">
                    {{ match.odds?.odd0 ? formatOddsValue(match.odds.odd0) : '-' }}
                  </div>
                  <div class="px-[3px] w-fit mx-auto"
                       :class="{ 'bg-zt-light rounded-[2px]' : (match.localteam_goals - match.localteam_et_goals < match.visitorteam_goals - match.visitorteam_et_goals && isFinished) }">
                    {{ match.odds?.odd1 ? formatOddsValue(match.odds.odd2) : '-' }}
                  </div>
                </div>
              <div v-else-if="showLiveMatchesH2hButton && window.size.desktop && redirectToH2h"
                     class="mx-auto w-fit"
                     :class="{ 'hidden' : isLive || justFinished }">
                  <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="25" height="19" rx="3" fill="#B3B3B3" fill-opacity="0.75"/>
                    <path d="M7.58527 7.36C8.13194 7.36 8.56194 7.51667 8.87527 7.83C9.19527 8.14333 9.35527 8.58 9.35527 9.14C9.35527 9.32667 9.33527 9.52667 9.29527 9.74L8.71527 13H7.01527L7.55527 9.97C7.57527 9.85667 7.58527 9.75667 7.58527 9.67C7.58527 9.39 7.50527 9.17333 7.34527 9.02C7.19194 8.86667 6.97527 8.79 6.69527 8.79C6.36194 8.79 6.08194 8.89333 5.85527 9.1C5.62861 9.30667 5.48194 9.59667 5.41527 9.97V9.95L4.87527 13H3.16527L4.47527 5.6H6.18527L5.73527 8.16C5.95527 7.91333 6.22527 7.72 6.54527 7.58C6.86527 7.43333 7.21194 7.36 7.58527 7.36ZM10.1536 11.35C10.8802 10.83 11.4602 10.4 11.8936 10.06C12.3269 9.72 12.7002 9.37333 13.0136 9.02C13.3336 8.66 13.5202 8.31667 13.5736 7.99C13.5936 7.89667 13.6036 7.81 13.6036 7.73C13.6036 7.53667 13.5502 7.39 13.4436 7.29C13.3436 7.19 13.1902 7.14 12.9836 7.14C12.4702 7.14 12.1436 7.50333 12.0036 8.23H10.3436C10.5169 7.39 10.8769 6.76 11.4236 6.34C11.9769 5.91333 12.6102 5.7 13.3236 5.7C14.0169 5.7 14.5302 5.85667 14.8636 6.17C15.2036 6.48333 15.3736 6.89667 15.3736 7.41C15.3736 7.57 15.3602 7.71667 15.3336 7.85C15.2136 8.53 14.8602 9.16333 14.2736 9.75C13.6936 10.3367 12.9736 10.9233 12.1136 11.51H14.8136L14.5636 12.9H9.54355L9.76355 11.63L10.1536 11.35ZM19.7364 7.36C20.2831 7.36 20.7131 7.51667 21.0264 7.83C21.3464 8.14333 21.5064 8.58 21.5064 9.14C21.5064 9.32667 21.4864 9.52667 21.4464 9.74L20.8664 13H19.1664L19.7064 9.97C19.7264 9.85667 19.7364 9.75667 19.7364 9.67C19.7364 9.39 19.6564 9.17333 19.4964 9.02C19.3431 8.86667 19.1264 8.79 18.8464 8.79C18.5131 8.79 18.2331 8.89333 18.0064 9.1C17.7798 9.30667 17.6331 9.59667 17.5664 9.97V9.95L17.0264 13H15.3164L16.6264 5.6H18.3364L17.8864 8.16C18.1064 7.91333 18.3764 7.72 18.6964 7.58C19.0164 7.43333 19.3631 7.36 19.7364 7.36Z" fill="#3A4B64"/>
                  </svg>
                </div>
              </div>
            </div>
          </Transition>
          <span v-if="showH2hButton && !redirectToH2h"
                :class="{ 'opacity-[20%] !cursor-default' : !redirectToH2h, '!opacity-0' : isLive }"
                class="cursor-pointer no-default-style pl-px pr-[9px]">
        <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="25" height="19" rx="3" fill="#B3B3B3" fill-opacity="0.75"/>
          <path d="M7.58527 7.36C8.13194 7.36 8.56194 7.51667 8.87527 7.83C9.19527 8.14333 9.35527 8.58 9.35527 9.14C9.35527 9.32667 9.33527 9.52667 9.29527 9.74L8.71527 13H7.01527L7.55527 9.97C7.57527 9.85667 7.58527 9.75667 7.58527 9.67C7.58527 9.39 7.50527 9.17333 7.34527 9.02C7.19194 8.86667 6.97527 8.79 6.69527 8.79C6.36194 8.79 6.08194 8.89333 5.85527 9.1C5.62861 9.30667 5.48194 9.59667 5.41527 9.97V9.95L4.87527 13H3.16527L4.47527 5.6H6.18527L5.73527 8.16C5.95527 7.91333 6.22527 7.72 6.54527 7.58C6.86527 7.43333 7.21194 7.36 7.58527 7.36ZM10.1536 11.35C10.8802 10.83 11.4602 10.4 11.8936 10.06C12.3269 9.72 12.7002 9.37333 13.0136 9.02C13.3336 8.66 13.5202 8.31667 13.5736 7.99C13.5936 7.89667 13.6036 7.81 13.6036 7.73C13.6036 7.53667 13.5502 7.39 13.4436 7.29C13.3436 7.19 13.1902 7.14 12.9836 7.14C12.4702 7.14 12.1436 7.50333 12.0036 8.23H10.3436C10.5169 7.39 10.8769 6.76 11.4236 6.34C11.9769 5.91333 12.6102 5.7 13.3236 5.7C14.0169 5.7 14.5302 5.85667 14.8636 6.17C15.2036 6.48333 15.3736 6.89667 15.3736 7.41C15.3736 7.57 15.3602 7.71667 15.3336 7.85C15.2136 8.53 14.8602 9.16333 14.2736 9.75C13.6936 10.3367 12.9736 10.9233 12.1136 11.51H14.8136L14.5636 12.9H9.54355L9.76355 11.63L10.1536 11.35ZM19.7364 7.36C20.2831 7.36 20.7131 7.51667 21.0264 7.83C21.3464 8.14333 21.5064 8.58 21.5064 9.14C21.5064 9.32667 21.4864 9.52667 21.4464 9.74L20.8664 13H19.1664L19.7064 9.97C19.7264 9.85667 19.7364 9.75667 19.7364 9.67C19.7364 9.39 19.6564 9.17333 19.4964 9.02C19.3431 8.86667 19.1264 8.79 18.8464 8.79C18.5131 8.79 18.2331 8.89333 18.0064 9.1C17.7798 9.30667 17.6331 9.59667 17.5664 9.97V9.95L17.0264 13H15.3164L16.6264 5.6H18.3364L17.8864 8.16C18.1064 7.91333 18.3764 7.72 18.6964 7.58C19.0164 7.43333 19.3631 7.36 19.7364 7.36Z" fill="#3A4B64"/>
        </svg>
      </span>
        </template>
        <div v-if="isReferee && refereeStats !== undefined && refereeStats.hasOwnProperty('name') && window.size.desktop" class="flex flex-col
    gap-y-1 items-end mr-2 text-xs font-['lato'] !basis-full w-full xl:!w-[400px]">
          <div>
            <span class="opacity-70 text-xs">{{this.refereeStats.name.split(',')[0].trim()}}</span>
            <svg class="inline-block ml-1" xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
              <path d="M11.8457 4.5H2.0957V9.5625L7.8932 11.25V11.1975C8.34457 12.0183 9.04084 12.6778 9.8849 13.084C10.729 13.4902 11.6788 13.6229 12.6018 13.4635C13.5249 13.3042 14.3752 12.8608 15.0343 12.1951C15.6933 11.5294 16.1281 10.6746 16.2782 9.75H17.0957V8.25H16.2782C16.1011 7.2022 15.5589 6.25089 14.7476 5.56454C13.9364 4.87818 12.9084 4.50108 11.8457 4.5ZM3.5957 8.4375V6H8.5007C8.066 6.4684 7.73773 7.02525 7.53837 7.63239C7.33901 8.23952 7.27329 8.88259 7.3457 9.5175L3.5957 8.4375ZM11.8457 12C11.2524 12 10.6723 11.8241 10.179 11.4944C9.68564 11.1648 9.30113 10.6962 9.07406 10.1481C8.847 9.59987 8.78759 8.99667 8.90335 8.41473C9.0191 7.83279 9.30482 7.29824 9.72438 6.87868C10.1439 6.45912 10.6785 6.1734 11.2604 6.05764C11.8424 5.94189 12.4456 6.0013 12.9938 6.22836C13.5419 6.45542 14.0105 6.83994 14.3401 7.33329C14.6698 7.82664 14.8457 8.40666 14.8457 9C14.8457 9.79565 14.5296 10.5587 13.967 11.1213C13.4044 11.6839 12.6414 12 11.8457 12Z" fill="#93A3BA"/>
              <path d="M12.5957 8.25H11.0957V9.75H12.5957V8.25Z" fill="#93A3BA"/>
            </svg>
          </div>
          <div class="flex space-x-2">
            <div>
              <svg class="inline-block -translate-y-[2px]" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M11.375 2.1875H2.625C1.90013 2.1875 1.3125 2.77513 1.3125 3.5V11.375C1.3125 12.0999 1.90013 12.6875 2.625 12.6875H11.375C12.0999 12.6875 12.6875 12.0999 12.6875 11.375V3.5C12.6875 2.77513 12.0999 2.1875 11.375 2.1875Z" stroke="white" stroke-width="0.341463" stroke-linejoin="round"/>
                <path d="M3.5 1.3125V2.1875M10.5 1.3125V2.1875" stroke="white" stroke-width="0.341463" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.6875 4.375H1.3125" stroke="white" stroke-width="0.341463" stroke-linejoin="round"/>
                <path d="M6.5724 5.84435C6.04172 5.92296 5.48578 6.20936 5.12076 6.59122C4.83155 6.89447 4.56762 7.40268 4.47777 7.82385C4.42442 8.07375 4.42723 8.64374 4.48339 8.91329C4.67713 9.8539 5.3875 10.6092 6.31127 10.8563C6.59486 10.9321 7.08342 10.9574 7.38667 10.9153C7.86961 10.8423 8.45083 10.5446 8.81865 10.1768C9.57676 9.41869 9.78173 8.19729 9.30721 7.25387C9.26509 7.17244 9.22578 7.10225 9.21455 7.09382C9.20613 7.0854 9.14716 7.00397 9.0882 6.91131C8.93377 6.67546 8.58841 6.34694 8.32448 6.1869C7.93419 5.95385 7.36982 5.79661 6.95707 5.80504C6.87564 5.80784 6.70437 5.82469 6.5724 5.84435ZM7.37824 6.34133C7.49898 6.36098 7.55794 6.38345 7.56637 6.41714C7.57198 6.44241 7.6141 6.61088 7.65622 6.79058L7.73203 7.1219L7.6141 7.27352C7.54671 7.35776 7.47932 7.43918 7.46248 7.45042C7.44282 7.46445 7.2547 7.45884 7.02446 7.43357L6.62013 7.39426L6.4994 7.20614L6.37866 7.01801L6.51063 6.66423L6.64259 6.31044L6.78299 6.30202C6.95988 6.29079 7.15642 6.30202 7.37824 6.34133ZM5.87045 7.25106C5.95468 7.2651 5.98837 7.29599 6.08946 7.44761L6.20738 7.62731L6.05295 8.01479L5.89572 8.40507L5.68794 8.4528C5.57282 8.48088 5.46331 8.49211 5.44366 8.48088C5.41277 8.46404 4.96352 8.12429 4.90737 8.07656C4.87086 8.04567 4.9916 7.64135 5.10391 7.41391L5.21061 7.19771L5.49139 7.21737C5.64582 7.2286 5.8171 7.24264 5.87045 7.25106ZM8.7653 7.45603C8.86077 7.45884 8.872 7.47007 8.92815 7.59642C9.00958 7.78454 9.07135 8.06252 9.07135 8.23099L9.06855 8.37138L8.74565 8.55108L8.41994 8.72797L8.23462 8.65216C8.13074 8.60723 8.03808 8.56512 8.02685 8.55669C8.01562 8.54546 7.96227 8.36015 7.91173 8.14394L7.81626 7.74804L7.95946 7.58238L8.09985 7.41672L8.38344 7.43357C8.53787 7.4448 8.70915 7.45322 8.7653 7.45603ZM6.28881 9.09018C6.42078 9.19968 6.56398 9.31761 6.6089 9.35131C6.69033 9.41588 6.69033 9.41869 6.67067 9.62928L6.65102 9.83986L6.33374 10.0505L6.01645 10.2638L5.83956 10.16C5.59528 10.0168 5.29765 9.73036 5.32011 9.65736C5.32854 9.62928 5.39873 9.46643 5.47174 9.29796L5.60651 8.9919L5.78902 8.94417C5.88729 8.9189 5.98837 8.89644 6.01084 8.89363C6.0333 8.89363 6.15965 8.98067 6.28881 9.09018ZM8.08581 9.10983L8.24024 9.18564L8.3329 9.52258C8.38063 9.7079 8.42275 9.86794 8.42556 9.87917C8.42836 9.95499 8.04931 10.2189 7.77414 10.3312L7.67306 10.3733L7.38947 10.1235L7.10588 9.87075V9.65455V9.43835L7.45125 9.22215C7.8303 8.98348 7.82749 8.98348 8.08581 9.10983Z" fill="white"/>
              </svg>
              {{ this.refereeStats.matches.length }}
            </div>
            <div>
              <svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                <g clip-path="url(#clip0_39090_178504)">
                  <path d="M0.996875 0.660156C0.867383 0.698242 0.742969 0.794726 0.669336 0.911523L0.595703 1.02578V4.57539V8.125H0.951172H1.30664V4.78867V1.45488L1.35996 1.38633L1.41074 1.32031H7.08555H12.7604L12.8213 1.38379L12.8848 1.44473V4.78613V8.125H13.2402H13.5957L13.5906 4.5627L13.583 1.00039L13.5145 0.89375C13.4764 0.83789 13.39 0.75664 13.324 0.718554L13.2021 0.64746L7.13379 0.642383C3.79746 0.639843 1.03496 0.64746 0.996875 0.660156Z" fill="white"/>
                  <path d="M1.6875 2.34746V3.02285L2.20801 4.97031C2.49492 6.0418 2.73613 6.93555 2.74121 6.9584C2.75137 6.98887 2.62187 7.0752 2.2207 7.30879L1.6875 7.62109V7.875V8.12891L1.7459 8.09336C1.77637 8.07305 2.08359 7.8877 2.42637 7.68457L3.05098 7.31133H7.17695H11.3029L11.892 7.69219C12.217 7.90039 12.4861 8.07305 12.4937 8.07305C12.4988 8.07305 12.5039 7.96133 12.5039 7.82422V7.57793L12.0697 7.29863C11.8311 7.14629 11.6279 7.00664 11.6229 6.98887C11.6152 6.97363 11.8107 6.11543 12.057 5.08457L12.5039 3.21074V2.44141C12.5039 1.78633 12.4988 1.67461 12.4658 1.67461C12.4201 1.67461 12.4836 1.42832 11.793 4.34063C11.4705 5.70156 11.2014 6.83652 11.1937 6.85938C11.1811 6.90254 10.9678 6.90508 7.17441 6.90508H3.17031L2.46953 4.29492C1.92617 2.27383 1.76113 1.68477 1.72812 1.67969C1.69258 1.67207 1.6875 1.73555 1.6875 2.34746Z" fill="white"/>
                  <path d="M6.73934 6.73204C6.25945 6.80314 5.75672 7.06212 5.42664 7.40743C5.16512 7.68165 4.92645 8.14122 4.8452 8.52208C4.79695 8.74806 4.79949 9.26349 4.85027 9.50724C5.02547 10.3578 5.66785 11.0408 6.5032 11.2643C6.75965 11.3328 7.20145 11.3557 7.47567 11.3176C7.91238 11.2516 8.43797 10.9824 8.77059 10.6498C9.45613 9.96427 9.64149 8.85978 9.21238 8.00665C9.1743 7.93302 9.13875 7.86954 9.12859 7.86193C9.12098 7.85431 9.06766 7.78068 9.01434 7.69689C8.87469 7.48361 8.56238 7.18654 8.32371 7.04181C7.97078 6.83107 7.46043 6.68888 7.08719 6.6965C7.01356 6.69904 6.85867 6.71427 6.73934 6.73204ZM7.46805 7.18146C7.57723 7.19923 7.63055 7.21954 7.63816 7.25001C7.64324 7.27286 7.68133 7.42521 7.71942 7.58771L7.78797 7.88732L7.68133 8.02443C7.62039 8.1006 7.55945 8.17423 7.54422 8.18439C7.52645 8.19708 7.35633 8.192 7.14813 8.16915L6.7825 8.13361L6.67332 7.96349L6.56414 7.79337L6.68348 7.47345L6.80281 7.15353L6.92977 7.14591C7.08973 7.13575 7.26746 7.14591 7.46805 7.18146ZM6.10457 8.00411C6.18074 8.01681 6.21121 8.04474 6.30262 8.18185L6.40926 8.34435L6.26961 8.69474L6.12742 9.04767L5.93953 9.09083C5.83543 9.11622 5.73641 9.12638 5.71863 9.11622C5.6907 9.10099 5.28445 8.79376 5.23367 8.7506C5.20067 8.72267 5.30984 8.35704 5.41141 8.15138L5.50789 7.95587L5.7618 7.97365C5.90145 7.9838 6.05633 7.9965 6.10457 8.00411ZM8.72234 8.18947C8.80867 8.192 8.81883 8.20216 8.86961 8.31642C8.94324 8.48654 8.9991 8.7379 8.9991 8.89025L8.99656 9.0172L8.70457 9.1797L8.41004 9.33966L8.24246 9.27111C8.14852 9.23048 8.06473 9.19239 8.05457 9.18478C8.04441 9.17462 7.99617 9.00704 7.95047 8.81154L7.86414 8.45353L7.99363 8.30372L8.12059 8.15392L8.37703 8.16915C8.51668 8.17931 8.67156 8.18693 8.72234 8.18947ZM6.48289 9.6672C6.60223 9.76622 6.73172 9.87286 6.77234 9.90333C6.84598 9.96173 6.84598 9.96427 6.8282 10.1547L6.81043 10.3451L6.52352 10.5356L6.2366 10.7285L6.07664 10.6346C5.85574 10.5051 5.5866 10.2461 5.60692 10.1801C5.61453 10.1547 5.67801 10.0074 5.74402 9.85509L5.8659 9.57833L6.03094 9.53517C6.11981 9.51232 6.21121 9.492 6.23152 9.48947C6.25184 9.48947 6.36609 9.56818 6.48289 9.6672ZM8.10789 9.68497L8.24754 9.75353L8.33133 10.0582C8.37449 10.2258 8.41258 10.3705 8.41512 10.3807C8.41766 10.4492 8.07488 10.6879 7.82606 10.7895L7.73465 10.8276L7.4782 10.6016L7.22176 10.3731V10.1776V9.98204L7.53406 9.78654C7.87684 9.57072 7.8743 9.57072 8.10789 9.68497Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_39090_178504">
                    <rect width="13" height="13" fill="white" transform="translate(0.595703)"/>
                  </clipPath>
                </defs>
              </svg>
              {{ this.refereeStats.penalties }}
            </div>
            <div>
              <div class="inline-block shrink-0 bg-[#FAFF0A] w-[6px] h-[10px] rounded-[2px]"></div>
              {{ this.refereeStats.yellow_cards }}
            </div>
            <div>
              <div class="inline-block shrink-0 bg-[#CA0000] w-[6px] h-[10px] rounded-[2px]"></div>
              {{ this.refereeStats.red_cards }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isReferee && refereeStats !== undefined && refereeStats.hasOwnProperty('name') && window.size.mobile"
         class="flex items-center bg-zt-light-opacity mr-2 text-xs font-['lato'] !basis-full w-full h-7 border-b px-2 border-zt-light relative">
      <hr class="border-zt-light border-dashed w-[calc(100%_-_8px)] absolute top-0 left-1">
      <div class="max-w-full flex flex-nowrap">
        <svg class="inline-block mr-1" xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
          <path d="M11.8457 4.5H2.0957V9.5625L7.8932 11.25V11.1975C8.34457 12.0183 9.04084 12.6778 9.8849 13.084C10.729 13.4902 11.6788 13.6229 12.6018 13.4635C13.5249 13.3042 14.3752 12.8608 15.0343 12.1951C15.6933 11.5294 16.1281 10.6746 16.2782 9.75H17.0957V8.25H16.2782C16.1011 7.2022 15.5589 6.25089 14.7476 5.56454C13.9364 4.87818 12.9084 4.50108 11.8457 4.5ZM3.5957 8.4375V6H8.5007C8.066 6.4684 7.73773 7.02525 7.53837 7.63239C7.33901 8.23952 7.27329 8.88259 7.3457 9.5175L3.5957 8.4375ZM11.8457 12C11.2524 12 10.6723 11.8241 10.179 11.4944C9.68564 11.1648 9.30113 10.6962 9.07406 10.1481C8.847 9.59987 8.78759 8.99667 8.90335 8.41473C9.0191 7.83279 9.30482 7.29824 9.72438 6.87868C10.1439 6.45912 10.6785 6.1734 11.2604 6.05764C11.8424 5.94189 12.4456 6.0013 12.9938 6.22836C13.5419 6.45542 14.0105 6.83994 14.3401 7.33329C14.6698 7.82664 14.8457 8.40666 14.8457 9C14.8457 9.79565 14.5296 10.5587 13.967 11.1213C13.4044 11.6839 12.6414 12 11.8457 12Z" fill="#93A3BA"/>
          <path d="M12.5957 8.25H11.0957V9.75H12.5957V8.25Z" fill="#93A3BA"/>
        </svg>
        <span class="opacity-70 text-xs max-w-[170px] truncate xl:max-w-full">{{this.refereeStats?.name.split(',')[0].trim()}}</span>
      </div>
      <div class="flex space-x-3 ml-auto shrink-0">
        <div>
          <svg class="inline-block -translate-y-[2px]" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M11.375 2.1875H2.625C1.90013 2.1875 1.3125 2.77513 1.3125 3.5V11.375C1.3125 12.0999 1.90013 12.6875 2.625 12.6875H11.375C12.0999 12.6875 12.6875 12.0999 12.6875 11.375V3.5C12.6875 2.77513 12.0999 2.1875 11.375 2.1875Z" stroke="white" stroke-width="0.341463" stroke-linejoin="round"/>
            <path d="M3.5 1.3125V2.1875M10.5 1.3125V2.1875" stroke="white" stroke-width="0.341463" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.6875 4.375H1.3125" stroke="white" stroke-width="0.341463" stroke-linejoin="round"/>
            <path d="M6.5724 5.84435C6.04172 5.92296 5.48578 6.20936 5.12076 6.59122C4.83155 6.89447 4.56762 7.40268 4.47777 7.82385C4.42442 8.07375 4.42723 8.64374 4.48339 8.91329C4.67713 9.8539 5.3875 10.6092 6.31127 10.8563C6.59486 10.9321 7.08342 10.9574 7.38667 10.9153C7.86961 10.8423 8.45083 10.5446 8.81865 10.1768C9.57676 9.41869 9.78173 8.19729 9.30721 7.25387C9.26509 7.17244 9.22578 7.10225 9.21455 7.09382C9.20613 7.0854 9.14716 7.00397 9.0882 6.91131C8.93377 6.67546 8.58841 6.34694 8.32448 6.1869C7.93419 5.95385 7.36982 5.79661 6.95707 5.80504C6.87564 5.80784 6.70437 5.82469 6.5724 5.84435ZM7.37824 6.34133C7.49898 6.36098 7.55794 6.38345 7.56637 6.41714C7.57198 6.44241 7.6141 6.61088 7.65622 6.79058L7.73203 7.1219L7.6141 7.27352C7.54671 7.35776 7.47932 7.43918 7.46248 7.45042C7.44282 7.46445 7.2547 7.45884 7.02446 7.43357L6.62013 7.39426L6.4994 7.20614L6.37866 7.01801L6.51063 6.66423L6.64259 6.31044L6.78299 6.30202C6.95988 6.29079 7.15642 6.30202 7.37824 6.34133ZM5.87045 7.25106C5.95468 7.2651 5.98837 7.29599 6.08946 7.44761L6.20738 7.62731L6.05295 8.01479L5.89572 8.40507L5.68794 8.4528C5.57282 8.48088 5.46331 8.49211 5.44366 8.48088C5.41277 8.46404 4.96352 8.12429 4.90737 8.07656C4.87086 8.04567 4.9916 7.64135 5.10391 7.41391L5.21061 7.19771L5.49139 7.21737C5.64582 7.2286 5.8171 7.24264 5.87045 7.25106ZM8.7653 7.45603C8.86077 7.45884 8.872 7.47007 8.92815 7.59642C9.00958 7.78454 9.07135 8.06252 9.07135 8.23099L9.06855 8.37138L8.74565 8.55108L8.41994 8.72797L8.23462 8.65216C8.13074 8.60723 8.03808 8.56512 8.02685 8.55669C8.01562 8.54546 7.96227 8.36015 7.91173 8.14394L7.81626 7.74804L7.95946 7.58238L8.09985 7.41672L8.38344 7.43357C8.53787 7.4448 8.70915 7.45322 8.7653 7.45603ZM6.28881 9.09018C6.42078 9.19968 6.56398 9.31761 6.6089 9.35131C6.69033 9.41588 6.69033 9.41869 6.67067 9.62928L6.65102 9.83986L6.33374 10.0505L6.01645 10.2638L5.83956 10.16C5.59528 10.0168 5.29765 9.73036 5.32011 9.65736C5.32854 9.62928 5.39873 9.46643 5.47174 9.29796L5.60651 8.9919L5.78902 8.94417C5.88729 8.9189 5.98837 8.89644 6.01084 8.89363C6.0333 8.89363 6.15965 8.98067 6.28881 9.09018ZM8.08581 9.10983L8.24024 9.18564L8.3329 9.52258C8.38063 9.7079 8.42275 9.86794 8.42556 9.87917C8.42836 9.95499 8.04931 10.2189 7.77414 10.3312L7.67306 10.3733L7.38947 10.1235L7.10588 9.87075V9.65455V9.43835L7.45125 9.22215C7.8303 8.98348 7.82749 8.98348 8.08581 9.10983Z" fill="white"/>
          </svg>
          {{ this.refereeStats.matches.length }}
        </div>
        <div>
          <svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
            <g clip-path="url(#clip0_39090_178504)">
              <path d="M0.996875 0.660156C0.867383 0.698242 0.742969 0.794726 0.669336 0.911523L0.595703 1.02578V4.57539V8.125H0.951172H1.30664V4.78867V1.45488L1.35996 1.38633L1.41074 1.32031H7.08555H12.7604L12.8213 1.38379L12.8848 1.44473V4.78613V8.125H13.2402H13.5957L13.5906 4.5627L13.583 1.00039L13.5145 0.89375C13.4764 0.83789 13.39 0.75664 13.324 0.718554L13.2021 0.64746L7.13379 0.642383C3.79746 0.639843 1.03496 0.64746 0.996875 0.660156Z" fill="white"/>
              <path d="M1.6875 2.34746V3.02285L2.20801 4.97031C2.49492 6.0418 2.73613 6.93555 2.74121 6.9584C2.75137 6.98887 2.62187 7.0752 2.2207 7.30879L1.6875 7.62109V7.875V8.12891L1.7459 8.09336C1.77637 8.07305 2.08359 7.8877 2.42637 7.68457L3.05098 7.31133H7.17695H11.3029L11.892 7.69219C12.217 7.90039 12.4861 8.07305 12.4937 8.07305C12.4988 8.07305 12.5039 7.96133 12.5039 7.82422V7.57793L12.0697 7.29863C11.8311 7.14629 11.6279 7.00664 11.6229 6.98887C11.6152 6.97363 11.8107 6.11543 12.057 5.08457L12.5039 3.21074V2.44141C12.5039 1.78633 12.4988 1.67461 12.4658 1.67461C12.4201 1.67461 12.4836 1.42832 11.793 4.34063C11.4705 5.70156 11.2014 6.83652 11.1937 6.85938C11.1811 6.90254 10.9678 6.90508 7.17441 6.90508H3.17031L2.46953 4.29492C1.92617 2.27383 1.76113 1.68477 1.72812 1.67969C1.69258 1.67207 1.6875 1.73555 1.6875 2.34746Z" fill="white"/>
              <path d="M6.73934 6.73204C6.25945 6.80314 5.75672 7.06212 5.42664 7.40743C5.16512 7.68165 4.92645 8.14122 4.8452 8.52208C4.79695 8.74806 4.79949 9.26349 4.85027 9.50724C5.02547 10.3578 5.66785 11.0408 6.5032 11.2643C6.75965 11.3328 7.20145 11.3557 7.47567 11.3176C7.91238 11.2516 8.43797 10.9824 8.77059 10.6498C9.45613 9.96427 9.64149 8.85978 9.21238 8.00665C9.1743 7.93302 9.13875 7.86954 9.12859 7.86193C9.12098 7.85431 9.06766 7.78068 9.01434 7.69689C8.87469 7.48361 8.56238 7.18654 8.32371 7.04181C7.97078 6.83107 7.46043 6.68888 7.08719 6.6965C7.01356 6.69904 6.85867 6.71427 6.73934 6.73204ZM7.46805 7.18146C7.57723 7.19923 7.63055 7.21954 7.63816 7.25001C7.64324 7.27286 7.68133 7.42521 7.71942 7.58771L7.78797 7.88732L7.68133 8.02443C7.62039 8.1006 7.55945 8.17423 7.54422 8.18439C7.52645 8.19708 7.35633 8.192 7.14813 8.16915L6.7825 8.13361L6.67332 7.96349L6.56414 7.79337L6.68348 7.47345L6.80281 7.15353L6.92977 7.14591C7.08973 7.13575 7.26746 7.14591 7.46805 7.18146ZM6.10457 8.00411C6.18074 8.01681 6.21121 8.04474 6.30262 8.18185L6.40926 8.34435L6.26961 8.69474L6.12742 9.04767L5.93953 9.09083C5.83543 9.11622 5.73641 9.12638 5.71863 9.11622C5.6907 9.10099 5.28445 8.79376 5.23367 8.7506C5.20067 8.72267 5.30984 8.35704 5.41141 8.15138L5.50789 7.95587L5.7618 7.97365C5.90145 7.9838 6.05633 7.9965 6.10457 8.00411ZM8.72234 8.18947C8.80867 8.192 8.81883 8.20216 8.86961 8.31642C8.94324 8.48654 8.9991 8.7379 8.9991 8.89025L8.99656 9.0172L8.70457 9.1797L8.41004 9.33966L8.24246 9.27111C8.14852 9.23048 8.06473 9.19239 8.05457 9.18478C8.04441 9.17462 7.99617 9.00704 7.95047 8.81154L7.86414 8.45353L7.99363 8.30372L8.12059 8.15392L8.37703 8.16915C8.51668 8.17931 8.67156 8.18693 8.72234 8.18947ZM6.48289 9.6672C6.60223 9.76622 6.73172 9.87286 6.77234 9.90333C6.84598 9.96173 6.84598 9.96427 6.8282 10.1547L6.81043 10.3451L6.52352 10.5356L6.2366 10.7285L6.07664 10.6346C5.85574 10.5051 5.5866 10.2461 5.60692 10.1801C5.61453 10.1547 5.67801 10.0074 5.74402 9.85509L5.8659 9.57833L6.03094 9.53517C6.11981 9.51232 6.21121 9.492 6.23152 9.48947C6.25184 9.48947 6.36609 9.56818 6.48289 9.6672ZM8.10789 9.68497L8.24754 9.75353L8.33133 10.0582C8.37449 10.2258 8.41258 10.3705 8.41512 10.3807C8.41766 10.4492 8.07488 10.6879 7.82606 10.7895L7.73465 10.8276L7.4782 10.6016L7.22176 10.3731V10.1776V9.98204L7.53406 9.78654C7.87684 9.57072 7.8743 9.57072 8.10789 9.68497Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_39090_178504">
                <rect width="13" height="13" fill="white" transform="translate(0.595703)"/>
              </clipPath>
            </defs>
          </svg>
          {{ this.refereeStats.penalties }}
        </div>
        <div>
          <div class="inline-block shrink-0 bg-[#FAFF0A] w-[6px] h-[10px] rounded-[2px]"></div>
          {{ this.refereeStats.yellow_cards }}
        </div>
        <div>
          <div class="inline-block shrink-0 bg-[#CA0000] w-[6px] h-[10px] rounded-[2px]"></div>
          {{ this.refereeStats.red_cards }}
        </div>
      </div>
    </div>
    <transition name="slide-fade" mode="out-in">
      <div v-if="showDetails" class="flex flex-col px-5 xl:px-[60px]">
        <div class="text-xs font-normal text-zt-more py-2.5 border-t border-zt-light border-dashed text-center" v-if="eventsToShow.length === 0">
          Brak wyróżnionych zdarzeń
        </div>
        <football-match-event-item v-for="(event, index) in eventsToShow"
        :event="event"
        :show-border="!((showVisitorGoalString || showLocalGoalString) && index === 0)"
        :match="match"
        :visitor-team="visitorTeam"
        :local-team="localTeam"
        :is-second-yellow="isSecondYellowCard(event)"
        />
        <div v-if="extraTimeEventsToShow.length > 0 || match.elapsed > 90 || ['AET', 'PEN', 'ET'].includes(match.status)"
           class="flex justify-center text-xs items-center w-full -my-2"
           :class="{'mb-6' : extraTimeEventsToShow.length === 0}">
          <span class="line"></span>
          <span class="text-zt-more">DOGRYWKA</span>
          <span class="line"></span>
        </div>
        <div class="text-xs font-normal text-zt-more py-2.5 border-t border-zt-light border-dashed text-center"
             v-if="['AET', 'PEN', 'ET'].includes(match.status) &&extraTimeEventsToShow.length === 0"
             :class="{'mb-1' : penaltyShootoutEventsToShow.length === 0}">
          Brak wyróżnionych zdarzeń
        </div>
        <football-match-event-item v-for="(event, index) in extraTimeEventsToShow"
         :event="event"
         :show-border="index !== 0"
         :match="match"
         :visitor-team="visitorTeam"
         :local-team="localTeam"
         :is-second-yellow="isSecondYellowCard(event)"
        />
        <div v-if="penaltyShootoutEventsToShow.length > 0 || ['PEN'].includes(match.status)" class="flex justify-center text-xs items-center w-full -my-2"
             :class="{'mb-6' : penaltyShootoutEventsToShow.length === 0}">
          <span class="line"></span>
          <span class="text-zt-more">KARNE</span>
          <span class="line"></span>
        </div>
        <div class="text-xs font-normal text-zt-more py-2.5 border-t border-zt-light border-dashed text-center"
             v-if="penaltyShootoutEventsToShow.length === 0 && ['PEN'].includes(match.status)">
          Brak danych
        </div>
        <football-match-event-item v-for="(event, index) in penaltyShootoutEventsToShow"
         :event="event"
         :show-border="index !== 0"
         :match="match"
         :visitor-team="visitorTeam"
         :local-team="localTeam"
         :is-first-event-in-pair="isFirstEventInPair(event, index)"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import utils_mixin from '../../mixins/utils_mixin';
import { lazyLoad } from "../../../assets/js/utils";
import football_mixin from "../../mixins/football_mixin";
import {useStatsStore} from "../../stores/StatsStore";
import FootballMatchEventItem from "./FootballMatchEventItem.vue";

export default {
  name: 'FootballStatsListItem',
  mixins: [utils_mixin, football_mixin],
  props: {
    match: Object,
    showStandingsIcon: {
      type: Boolean,
      default: false
    },
	  teamId: {
			type: Number,
		  default: 0
	  },
	  redirectToH2h: {
			type: Boolean,
		  default: true
	  },
	  analyticType: {
		  type: String,
		  default: ''
	  },
	  filteringResult: {
			type: String,
		  default: '',
	  },
	  displayingStat: {
			type: String,
		  default: 'goals',
	  },
    showScores: {
      type: Boolean,
      default: true,
    },
    showOdds: {
      type: Boolean,
      default: false,
    },
    showHour: {
      type: Boolean,
      default: false,
    },
    showDate: {
      type: Boolean,
      default: false,
    },
	  markWinner: {
			type: Boolean,
		  default: true,
	  },
    showFinished: {
      type: Boolean,
      default: false,
    },
	  showLeagueName: {
		  type: Boolean,
		  default: false,
	  },
	  showPromotionIcon: {
			type: Boolean,
		  default: false
	  },
	  currentFilters: {
			type: Array,
		  default: null,
	  },
	  biggerCrest: {
			type: Boolean,
		  default: false
	  },
    hourOnlyInTodaysMatches: {
			type: Boolean,
		  default: false
	  },
    showOnlyInProgress: {
      type: Boolean,
      default: false
    },
	  showH2hButton: {
			type: Boolean,
		  default: false
	  },
	  showLiveMatchesH2hButton: {
			type: Boolean,
		  default: false
	  },
	  variant: {
			type: String,
		  default: 'default'
	  },
	  showRelativeDate: {
			type: Boolean,
		  default: true
	  },
    ish2h: {
      type: Boolean,
      default: false
    },
	  showAnimation: {
			type: Boolean,
		  default: false
	  },
	  showAppearAnimation: {
		  type: Boolean,
		  default: false
	  },
    shortLeagueName: {
      type: String,
      default: ''
    },
    showBreakers: {
      type: Boolean,
      default: false
    },
    showTeamsBg: {
      type: Array,
      default: []
    },
    isReferee: {
      type: Boolean,
      default: false
    },
    showEventArrow: {
      type: Boolean,
      default: false
    },
    showDoubleMatch: {
      type: Boolean,
      default: false
    },
    detailsEnabled: {
    	type: Boolean,
			default: false
    }
  },
  components: { FootballMatchEventItem },
  setup() {
    const statsStore = useStatsStore();
    return { statsStore };
  },
  data() {
    return {
      statuses: {
        'live': ['1H', 'HT', '2H', 'ET', 'BT', 'P', 'LIVE'],
        'ended': ['FT', 'AET', 'PEN', 'CANC', 'ABD', 'AWD', 'WO'],
        'upcoming': ['TBD', 'NS', 'PST'],
        'extra': ['AET', 'PEN']
      },
      showVisitorGoalString: false,
      showLocalGoalString: false,
      justFinished: false,
      showDetails: false,
      overValues: {
        'overunder': {
          min: 0.5,
          max: 5.5
        },
        'cards': {
          min: 1.5,
          max: 5.5
        },
        'corners': {
          min: 7.5,
          max: 12.5
        }
      },
    }
  },
  computed: {
    currentStatsForOverUnderAll() {
      if (!this.currentFilters) {
        return 0;
      }
      if (this.currentFilters[0] === 'overunder') {
        const match = this.match;
        return +match.localteam_goals + +match.visitorteam_goals - +match.localteam_et_goals - +match.visitorteam_et_goals;
      }
      if (this.currentFilters[0] === 'cards') {
        return +this.match.localteam_yellowcards + +this.match.visitorteam_yellowcards;
      }
      if (this.currentFilters[0] === 'corners') {
        return +this.match.localteam_corners + +this.match.visitorteam_corners;
      }
    },
    currentOverValues() {
      if (!this.currentFilters) {
        return [];
      }
      const bounds = this.overValues[this.currentFilters[0]];
      let values = [];
      for (let i = bounds.min; i <= bounds.max; i++) {
        values.push(i);
      }
      return values;
    },
    showAllOverUnder() {
      if (!this.currentFilters || this.ish2h) {
        return false;
      }
      return this.currentFilters[0] === 'overunder' && this.currentFilters[1] === 'all'
          || this.currentFilters[0] === 'cards' && this.currentFilters[1] === 'yellowcards' && this.currentFilters[2] === 'overunder' && this.currentFilters[3] === 'all'
          || this.currentFilters[0] === 'corners' && this.currentFilters[1] === 'overunder' && this.currentFilters[2] === 'all'
    },
		keyFilter() {
			return `${this.currentFilters?.join('-')}-${this.match.match_id}`;
		},
	  transitionName() {
			return this.showAnimation ? 'fade' : '';
	  },
		matchResultsText() {
			if (this.penaltyShootoutOccurred) {
				return 'karne';
			}
			if (this.match.overtime_occurred) {
				return 'dogr.';
			}
			return '';
		},
	  analyticText() {
		  if (this.analyticType === 'league-overview-timetable' && this.redirectToH2h) {
			  return 'LIGA - PRZEGLĄD wejścia w NAJBLIŻSZE MECZE';
		  }
		  if (this.analyticType === 'league-timetable') {
			  return '';
		  }
      if (this.analyticType === 'breakers') {
        return 'Ostatnie Łamaki (nowy projekt) - kliki w mecze';
      }
      if (window.location.pathname === '/') {
        return 'Strona główna - Wyniki na żywo';
      }
	  },
		penaltyShootoutOccurred() {
			return this.match.localteam_penalty_shootout && this.match.visitorteam_penalty_shootout &&
				(this.match.localteam_penalty_shootout !== '0' || this.match.visitorteam_penalty_shootout !== '0');
		},
    parsedFilteringResult() {
      if (!this.showPlusMinus) {
        return this.filteringResult;
      }
      if (this.filteringResult === 'W') {
        return '+';
      } else {
        return '-';
      }
    },
    showPlusMinus() {
      if (!this.currentFilters) {
        return false;
      }
      if (this.currentFilters[0] === 'corners' && this.currentFilters[1] === 'result') {
        return false;
      }
      if (this.currentFilters[0] === 'cards' && this.currentFilters[2] === 'result') {
        return false;
      }
      return this.currentFilters[0] !== '1x2' && this.currentFilters[0] !== 'halfs';
    },
    localTeamStat() {
      if (!this.showScores) {
        return ''
      }
      if (this.currentFilters && this.isLive && (this.displayingStat !== 'goals'|| this.currentFilters[0] === 'overunder' || this.currentFilters[0] === 'halfs')) {
        return '-'
      }
      if (this.matchStatus === 'CANC') {
        return '-';
      }
      if (this.displayingStat === 'corners') {
        return this.match.localteam_corners;
      }
      if (this.displayingStat === 'cards') {
        if (this.currentFilters[1] === 'yellowcards') {
          return this.match.localteam_yellowcards;
        } else {
          return this.match.localteam_red_cards
        }
      }
      if (this.displayingStat === 'firsthalf') {
        return this.match.localteam_ht_goals;
      }
      if (this.displayingStat === 'secondhalf') {
        return +this.match.localteam_goals - +this.match.localteam_ht_goals  - +this.match.localteam_et_goals;
      }
      if (this.displayingStat === 'penalty') {
        if (this.currentFilters[1] === 'for') {
          return +this.match.localteam_id === this.teamId ? this.match.localteam_penalties : this.match.visitorteam_penalties;
        } else  if (this.currentFilters[1] === 'against') {
          return +this.match.localteam_id === this.teamId ? this.match.visitorteam_penalties : this.match.localteam_penalties;
        }
        return +this.match.localteam_penalties + +this.match.visitorteam_penalties;
      }
      if (this.displayingStat === 'goals') {
        return this.match.localteam_goals;
      }
    },
    visitorTeamStat() {
      if (!this.showScores) {
        return ''
      }
      if (this.currentFilters && this.isLive && (this.displayingStat !== 'goals' || this.currentFilters[0] === 'overunder' || this.currentFilters[0] === 'halfs')) {
        return '-'
      }
      if (this.matchStatus === 'CANC') {
        return '-';
      }
      if (this.displayingStat === 'corners') {
        return this.match.visitorteam_corners;
      }
      if (this.displayingStat === 'cards') {
        if (this.currentFilters[1] === 'yellowcards') {
          return this.match.visitorteam_yellowcards;
        } else {
          return this.match.visitorteam_red_cards
        }
      }
      if (this.displayingStat === 'firsthalf') {
        return this.match.visitorteam_ht_goals;
      }
      if (this.displayingStat === 'secondhalf') {
        return +this.match.visitorteam_goals - +this.match.visitorteam_ht_goals  - +this.match.visitorteam_et_goals;
      }
      if (this.displayingStat === 'goals') {
        return this.match.visitorteam_goals;
      }
    },
    isToday() {
      return this.matchDate.startOf('day').equals(DateTime.now().startOf('day'));
    },
    isTomorrow() {
      return this.matchDate.startOf('day').equals(DateTime.now().startOf('day').plus({days: 1}));
    },
    isYesterday() {
      return this.matchDate.startOf('day').equals(DateTime.now().startOf('day').minus({days: 1}));
    },
    isOver30Days() {
      return this.matchDate.startOf('day').diffNow('day').days > 30;
    },
    isFinished() {
      return this.statuses['ended'].some((el) => el === this.match.status);
    },
    hasAdditionalTime() {
      return ['AET', 'PEN'].some((el) => el === this.match.status)
    },
    isLive() {
      return this.statuses['live'].some((el) => el === this.match.status);
    },
    getResult() {
			if (this.penaltyShootoutOccurred) {
				return +this.match.localteam_penalty_shootout - +this.match.visitorteam_penalty_shootout;
			}
      let result = +this.localTeamStat - +this.visitorTeamStat;
      return result !== 0 ? result : +this.match.localteam_et_goals - +this.match.visitorteam_et_goals;
    },
	  getDoubleMatchResult() {
			if (!this.match.hasOwnProperty('double_match') || !this.match.double_match.is_double_match || this.match.double_match.match_no === 1) {
				return this.getResult;
			}
			let currentMatchResult = this.getResult;
			const prevMatch = this.match.double_match.second_match;

		  if (this.penaltyShootoutOccurred) {
			  return +this.match.localteam_penalty_shootout - +this.match.visitorteam_penalty_shootout;
		  }
		  currentMatchResult += +prevMatch.visitorteam_goals - +prevMatch.localteam_goals;
		  return currentMatchResult;
	  },
    localTeam() {
      return {
        name: this.match.localteam_name,
        shortname: this.match.localteam_shortname,
        id: this.match.localteam_id,
        query_name: this.match.localteam_team_query_name,
        goals: this.match.localteam_goals,
      }
    },
    visitorTeam() {
      return {
        name: this.match.visitorteam_name,
        shortname: this.match.visitorteam_shortname,
        id: this.match.visitorteam_id,
        query_name: this.match.visitorteam_team_query_name,
        goals: this.match.visitorteam_goals,
      }
    },
    matchDate() {
      return DateTime.fromFormat(this.match.date, 'yyyy-MM-dd H:mm:ss');
    },
    matchStatus() {
      return this.match.status;
    },
    getMatchDateToDisplay() {
			if (this.variant === 'compact') {
				return this.matchDate.toFormat('dd.MM');
			}
      let date = new Date().getFullYear() === this.matchDate.get('year') ? this.matchDate.toFormat('d.MM') : this.matchDate.toFormat('d.MM.yy');
      let date_str = '';
      let hour = '';
      if (this.showHour) {
        hour = this.matchDate.toFormat('H:mm');
      }
      if (this.isTomorrow && this.showRelativeDate) {
        date_str = 'Jutro ' + hour;
      } else if (this.isToday && this.showRelativeDate) {
        date_str = 'Dziś ' + hour;
      } else if (this.isYesterday && this.showRelativeDate) {
        date_str = 'Wczoraj ' + hour;
      } else {
        date_str = date;
      }
      return date_str;
    },
    leagueName() {
      if (this.match.league_query_name) {
        return this.match.league_query_name;
      } else {
        if (this.match.localteam_league_query_name) {
          return this.match.localteam_league_query_name;
        } else {
          return '';
        }
      }
    },
    leagueId() {
      return +this.match.league_id;
    },
    isTWK() {
      return Date.now() - Date.parse(this.match.date);
    },
    refereeStats() {
      let refereeDetails = {};
      if (this.isReferee && this.statsStore.refereeStats[+this.match.league_id].length > 0) {
        refereeDetails = this.statsStore.refereeStats[+this.match.league_id].slice().find((el) => {
          const removeDiacritics = (str) =>
              str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

          let refName = this.match.referee.split(',')[0].trim();

          if (el.hasOwnProperty('all_names')) {
            return el.all_names.includes(refName) || el.all_names.toLowerCase().includes(refName.toLowerCase()) ||
                el.name === refName || el.name.toLowerCase() === refName.toLowerCase()
          }

          let parts = el.name.split(" ");
          let name = ' ';
          if (parts.length > 1) {
            name = `${parts[0][0]}. ${parts.slice(1).join(" ")}`;
          }

          let dbName = el.name.split(',')[0].trim();
          let shortName = name.split(',')[0].trim();

          refName = removeDiacritics(refName.toLowerCase());
          dbName = removeDiacritics(dbName.toLowerCase());
          shortName = removeDiacritics(shortName.toLowerCase());

          return dbName === refName || shortName === refName;
        });
      }

      if (refereeDetails && Object.keys(refereeDetails).length > 0) {
        return refereeDetails;
      }
      return {
          name : this.match.referee,
          matches : [],
          penalties : 0,
          red_cards: 0,
          yellow_cards : 0,
          last_name : '',
          first_name : '',
          short_name : '',
          all_names : ''
      };
    },
    eventsToShow() {
      let filteredEvents = this.match.events.slice().filter(el => !el.details.includes('Substitution') && !el.details.includes('confirmed')
          && +el.minute <= 90 && !(el.type === 'Var' && (el.details === 'Card upgrade' || el.details === 'Card reviewed' ||
              el.details === 'Goal cancelled' || el.details === ''))
          && el.details !== 'Yellow Card' && (parseInt(el.minute) > -5)
          && !(this.isSecondYellowCard(el) && el.details === 'Yellow Card'));
      const uniqueMap = new Map();

      filteredEvents.forEach(ev => {
        const key = `${ev.player_id}-${ev.minute}-${ev.type}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, ev);
        }
      });

      return Array.from(uniqueMap.values()).sort((a, b) => {
        const diff = +a.minute - +b.minute;
        if (diff !== 0) return diff;
        return +a.extra - +b.extra;
      });
    },
    extraTimeEventsToShow() {
      let filteredEvents = this.match.events.slice().filter(el => !el.details.includes('Substitution') && !el.details.includes('confirmed')
          && (+el.minute > 90) && (el.comments !== 'Penalty Shootout') && !(el.type === 'Var' &&
              (el.details === 'Card upgrade' || el.details === 'Card reviewed' || el.details === 'Goal cancelled' || el.details === ''))
          && !(this.isSecondYellowCard(el) && el.details === 'Yellow Card') && (parseInt(el.minute) > -5) && el.details !== 'Yellow Card');

      const uniqueMap = new Map();

      filteredEvents.forEach(ev => {
        const key = `${ev.player_id}-${ev.minute}-${ev.type}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, ev);
        }
      });

      return Array.from(uniqueMap.values()).sort((a, b) => {
        const diff = +a.minute - +b.minute;
        if (diff !== 0) return diff;
        return +a.extra - +b.extra;
      });
    },
    penaltyShootoutEventsToShow() {
      let penaltyEvents = this.match.events
          .slice()
          .filter(el =>
              !el.details.includes('Substitution') &&
              !el.details.includes('confirmed') &&
              el.comments === 'Penalty Shootout' &&
              !(el.type === 'Var' && el.details === 'Card upgrade')
          )
          .sort((a, b) => +a.extra - +b.extra);

      const uniqueMap = new Map();
      penaltyEvents.forEach(ev => {
        const key = `${ev.player_id}-${ev.extra}-${ev.type}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, ev);
        }
      });

      penaltyEvents = Array.from(uniqueMap.values());

      const startEvent = penaltyEvents.find(e => +e.extra === 1);
      if (!startEvent) {
        return penaltyEvents;
      }

      const firstTeamId = startEvent.team_id;
      const secondTeamId = penaltyEvents.find(e => e.team_id !== firstTeamId)?.team_id;

      const firstTeamEvents = penaltyEvents.filter(e => e.team_id === firstTeamId);
      const secondTeamEvents = penaltyEvents.filter(e => e.team_id === secondTeamId);

      const result = [];
      let useFirstTeam = true;

      while (firstTeamEvents.length || secondTeamEvents.length) {
        if (useFirstTeam) {
          if (firstTeamEvents.length) {
            result.push(firstTeamEvents.shift());
          } else if (secondTeamEvents.length) {
            result.push(secondTeamEvents.shift());
          }
        } else {
          if (secondTeamEvents.length) {
            result.push(secondTeamEvents.shift());
          } else if (firstTeamEvents.length) {
            result.push(firstTeamEvents.shift());
          }
        }
        useFirstTeam = !useFirstTeam;
      }

      return result;
    },
    isValidHour() {
      const hour = this.matchDate.toFormat('H:mm');

      const exceptions = [253, 307, 9, 913, 15, 1, 100011, 480, 6, 22, 490];

      if (exceptions.includes(this.leagueId)) {
        return true;
      }
      return hour !== '1:00' && hour !== '2:00' && hour !== '0:00';
    }
  },
  watch: {
    visitorTeam(newVal, oldVal) {
      if (Number(newVal.goals) > Number(oldVal.goals)) {
        this.showVisitorGoalString = true;
        setTimeout(() => {
          this.showVisitorGoalString = false
        }, 1000*30)
      }
    },
    localTeam(newVal, oldVal) {
      if (Number(newVal.goals) > Number(oldVal.goals)) {
        this.showLocalGoalString = true;
        setTimeout(() => {
          this.showLocalGoalString = false
        }, 1000*30)
      }
    },
    isLive(newVal, oldVal) {
      if ( oldVal === true ) {
        this.justFinished = true;
        setTimeout(() => {
          this.justFinished = false;
        }, 1000*60)
      }
    }
  },
  mounted() {
    if (this.variant === 'icon') {
      return;
    }
    setTimeout(() => lazyLoad([ this.$refs.localTeamImg, this.$refs.visitorTeamImg ]), 10);
  },
	methods: {
    shouldShowDoubleMatchResult(match) {
     return match.double_match?.is_double_match && +match.double_match?.match_no === 2 &&
         this.statuses.ended.includes(match.double_match?.second_match?.status) &&
         match.double_match?.second_match?.league_id !== '10' && this.showDoubleMatch
    },
		formatOddsValue(value) {
			value = parseFloat(value);
			if (value >= 1000) {
				return '999+';
			}
			if (value < 10) {
				return value.toFixed(2)
			}
			if (value >= 10) {
				return value.toFixed(1);
			}
		},
    checkIfMatchHasOdds() {
      return this.match.odds !== null && "odds" in this.match;
    },
    showDetailsHandler() {
			console.log('aaa');
      if (this.redirectToH2h && this.leagueName.length > 0 && this.variant !== 'live') {
        window.location = `/wyniki-pilka-nozna/porownanie-druzyn/${this.match.localteam_team_query_name}/${this.match.visitorteam_team_query_name}/`;
        return;
      }
      setTimeout(() => lazyLoad([ this.$refs.localTeamImg, this.$refs.visitorTeamImg ]), 10);
      if (this.statuses.upcoming.includes(this.match.status) || !this.showEventArrow) {
        return;
      }
      this.showDetails = !this.showDetails;
    },
    isSecondYellowCard(matchEvent) {
      let maxMinute = -1;
      if (matchEvent.details === 'Yellow Card') {
        let playerCards = this.match.events.slice().filter((el) => {
          return el.type === 'Card' && el.player_id === matchEvent.player_id;
        });
        let yellowCards = playerCards.slice().filter(el => el.details === 'Yellow Card');
        if (yellowCards.length > 1) {
          maxMinute = Math.max(...yellowCards.map(el => el.minute));
        } else {
          return false;
        }
        return (matchEvent.minute >= maxMinute && matchEvent.details === 'Yellow Card') || matchEvent.details === 'Red Card';
      }
      return false;
    },
    isFirstEventInPair(event, index) {
      return index % 2 === 0;
    },
	},
}
</script>

<style scoped>
.match-minutes-tick {
  font-weight: 900;
  margin-left: 1px;
  display: inline-block;
  animation: minutestick;
  animation-duration: 1s;
  animation-timing-function: steps(1, end);
  animation-iteration-count: infinite;
}

@keyframes minutestick {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.fade-enter-active,
.fade-appear-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-appear-from {
  opacity: 0;
}

.after-line {
  position: relative;
}

.after-line::after {
  content: '';
  position: absolute;
  right: 16px;
  top: 0;
  height: 100%;
  width: 1px;
  background-color: white;
  opacity: 0.4;
  border-radius: 50%;
}

.line {
  flex-grow: 1;
  height: 1px;
  background-color: #3A4B64; /* Kolor kreski */
  margin: 0 10px;
}

</style>